import { UNDERLINE_REG_EXP } from '../../../../../../constants/regex.constants';
import { MeetingAttendeeStatus } from '../../../../../../api/attendees.dao';

export const getCountOfAttendeesWithIssue = (attendees, selector): number => {
    return attendees.reduce((accumulator, value) => {
        const isAttendeeWithIssues: number = value[selector]?.length ? 1 : 0;
        return accumulator + isAttendeeWithIssues;
    }, 0);
};

export const formatPopoverData = (organizationWithAttendees, popoverData) => {
    return organizationWithAttendees.map(({attendees, organizationName}) => {
            attendees.forEach(attendee => {
                if (attendee.issues?.length || attendee.meetingAttendeeNote) {
                    const attendeeOrganization = organizationName;
                    const attendeeName = `${attendee.firstName} ${attendee.lastName}, ${attendeeOrganization}`;
                    const attendeeIssues = attendee.issues?.length ? attendee.issues.join(', ').replace(UNDERLINE_REG_EXP, ' ').toLowerCase() : null;
                    const attendeeStatus = attendee.status === MeetingAttendeeStatus.CONFIRMED ?
                        ''
                        : attendee.status?.replace(UNDERLINE_REG_EXP, ' ').toLowerCase();
                    const attendeeNote = attendee?.meetingAttendeeNote;
                    const attendeeId = attendee.attendeeId;

                    popoverData.push({
                        attendeeName: attendeeName,
                        attendeeIssues: attendeeIssues,
                        attendeeStatus: attendeeStatus,
                        attendeeNote: attendeeNote,
                        attendeeId: attendeeId
                    });
                }
            });
        }
    );
};

export const INTERACTIONS_REPORT_LABEL = {
    id: 'oe.reports.interactionsReport',
    defaultMessage: 'Interactions Report',
    description: 'Label text',
};

export const REGISTRATION_REPORT_LABEL = {
    id: 'oe.reports.registrationReport',
    defaultMessage: 'Registration Report',
    description: 'Label text',
};

export const GENERATE_REPORT_BUTTON_LABEL = {
    id: 'oe.reports.generateReport',
    defaultMessage: 'Generate Report',
    description: 'Button label',
};